import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FaqCategory, FaqItem } from '../models';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class FaqCategoriesService {
  private http = inject(HttpClient);
  private BASE_URL = inject(BASE_URL, { optional: true });

  getFaqCategories() {
    return this.http.get<FaqCategory[]>(`${this.BASE_URL}api/faq/categories`);
  }

  getFaq() {
    return this.http.get<FaqItem[]>(`${this.BASE_URL}api/faq`);
  }
}
